/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}inline-message`;
const attributes = {
    THEME: 'theme'
};
const defaults = {
    THEME: 'info'
};
export const INLINE_MESSAGE_CONSTANTS = {
    elementName,
    attributes,
    defaults
};
